import { RestError } from '@axa-fr-axion/restful';
import { QueryClient, QueryClientConfig } from '@tanstack/react-query';
import merge from 'lodash.merge';

/**
 * This function is used to create a QueryClient instance.
 * NOTE: Retry false in test will only work if your actual useQuery has not explicit retries set.
 * https://tanstack.com/query/v4/docs/react/guides/testing#turn-off-retries
 */
export const getQueryClient = (
    config = {},
    /* istanbul ignore next */
    options = {
        isMock: process.env.NODE_ENV === 'test' || process.env.REACT_APP_MOCK_ENABLED === 'true',
    }
): QueryClient => {
    const _config: QueryClientConfig = options.isMock
        ? {
            defaultOptions: {
                queries: {
                    gcTime: 0,
                    retry: false,
                },
            },
        }
        : {
            defaultOptions: {
                queries: {
                    retry: (_failureCount, err) => {
                        const error = err as RestError;
                        return error?.isDatadomeBlocked;
                    },
                },
            },
        };

    return new QueryClient(merge({}, _config, config));
};
